import React from "react";
import { useAuth } from "../context/AuthContext";
import { addInterventionsTicket, getTicket } from "../lib/ticket";
import { relanceAvaillable } from "../utils/relance";
import moment from "moment";
import { FaBell } from "react-icons/fa";
import { getDisplayTitle } from "../utils/titleformat";

const RelanceTicketModal = ({ onClose, onSubmitSuccess, onError, ticket }) => {
  const { userInfo } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    if (!relanceAvaillable(ticket)) {
      onError("Ce ticket ne peut pas encore être relancé.");
      return;
    }

    try {
      const now = moment().format("YYYY-MM-DD HH:mm:ss");
      const intervention = {
        utilisateur: 1013,
        description: `RELANCE par ${userInfo?.userName}: ${form.descriptionTicketAdd.value}`,
        date_debut: now,
        duree: 1,
      };
      await addInterventionsTicket(ticket.idTicket, intervention);
      const new_ticket = await getTicket(ticket.idTicket);
      if (new_ticket) {
        onClose();
        onSubmitSuccess();
      } else {
        onError();
      }
    } catch (error) {
      console.error("Erreur lors de la relance :", error);
      onError();
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal fade show d-block modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
        <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
          <div className="modal-content shadow-lg">
            <form onSubmit={handleSubmit}>
              <div className="modal-header bg-light border-bottom">
                <div>
                  <h5 className="modal-title font-weight-bold">
                    <FaBell className="me-2 text-info" />
                    Relancer le ticket
                  </h5>
                  <small className="text-muted">{getDisplayTitle(ticket?.titre)}</small>
                </div>
                <button type="button" className="btn-close" onClick={onClose} aria-label="Fermer" />
              </div>

              <div className="modal-body">
                <div className="form-group mb-0">
                  <label className="font-weight-semibold">Message</label>
                  <textarea
                    className="form-control"
                    name="descriptionTicketAdd"
                    rows={5}
                    placeholder="Votre message de relance..."
                  />
                </div>
              </div>

              <div className="modal-footer bg-light border-top">
                <button type="button" className="btn btn-secondary" onClick={onClose}>
                  Annuler
                </button>
                <button
                  type="submit"
                  className="btn btn-info text-white"
                  data-testid="relance-ticket-button-modal"
                >
                  Envoyer la relance
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default RelanceTicketModal;
